import { noop } from 'lodash-es';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './ExitAnnotationMode.module.css';
import { CloseBigIcon } from './icons';
export default function ExitAnnotationMode(_a) {
    var onClick = _a.onClick;
    return (React.createElement("div", { className: styles.closeWrap },
        React.createElement("div", { className: styles.close, onClick: onClick },
            React.createElement("div", { className: styles.iconWrap },
                React.createElement(CloseBigIcon, null)))));
}
ExitAnnotationMode.propTypes = {
    onClick: PropTypes.func,
};
ExitAnnotationMode.defaultProps = {
    onClick: noop,
};
